var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, firstStringProperty, propMerge } from '@shapeable/utils';
import { SvgCircleNode } from '../elements/svg-circle-node';
import { SvgLabel } from '../elements/svg-label';
import { useComponentProps } from '../context/component-props-context';
import { useLink } from '../hooks/use-link';
var cls = classNames('svg-entity-node');
export var SvgEntityNodeDefaultProps = {
  imagePaths: ['openGraph.image.thumbnails.medium.url', 'openGraph.image.thumbnails.small.url', 'openGraph.image.thumbnails.card.url', 'openGraph.image.thumbnails.full.url', 'openGraph.image.url'],
  outlineNumber: {
    colors: {
      fill: 'bright'
    }
  },
  circle: {
    strokeWidth: 2,
    colors: {
      stroke: 'bright',
      active: {
        stroke: 'strong'
      },
      hover: {
        stroke: 'strong'
      }
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "])))
});
var OutlineNumberStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SvgEntityNode',
  Container: styled(SvgCircleNode)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  OutlineNumber: styled(SvgLabel)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), OutlineNumberStyles)
};
export var SvgEntityNode = function (props) {
  var _a = useComponentProps(My.NAME, SvgEntityNodeDefaultProps, props),
    className = _a.className,
    children = _a.children,
    imagePaths = _a.imagePaths,
    entity = _a.entity,
    circleNodeProps = __rest(_a, ["className", "children", "imagePaths", "entity"]);
  var navigate = useLink().navigate;
  var isActive = circleNodeProps.isActive === undefined ? entity.isActive : circleNodeProps.isActive;
  var _b = React.useMemo(function () {
      var _a, _b, _c;
      // use entity color to fill the circle
      var circle = propMerge(circleNodeProps.circle, {
        colors: {
          fill: (_a = entity.color) === null || _a === void 0 ? void 0 : _a.value
        }
      });
      var label = propMerge(circleNodeProps.label, {
        text: entity.name
      });
      var outlineNumber = propMerge(circleNodeProps.outlineNumber, {
        text: entity.outlineNumber || '',
        fontSize: ((_b = circleNodeProps.outlineNumber) === null || _b === void 0 ? void 0 : _b.fontSize) === undefined ? circleNodeProps.r * 0.8 : (_c = circleNodeProps.outlineNumber) === null || _c === void 0 ? void 0 : _c.fontSize
      });
      return {
        circle: circle,
        label: label,
        outlineNumber: outlineNumber
      };
    }, [entity === null || entity === void 0 ? void 0 : entity.id]),
    circle = _b.circle,
    label = _b.label,
    outlineNumber = _b.outlineNumber;
  var imageUrl = circleNodeProps.imageUrl || firstStringProperty(entity, imagePaths);
  var showOutlineNumber = props.showOutlineNumber === undefined ? !!outlineNumber.text : props.showOutlineNumber;
  return React.createElement(My.Container, __assign({
    className: cls.name(className)
  }, circleNodeProps, {
    onClick: function () {
      navigate(entity.path);
    },
    isActive: isActive,
    circle: circle,
    label: label,
    imageUrl: imageUrl
  }), showOutlineNumber && React.createElement(My.OutlineNumber, __assign({}, outlineNumber, {
    dy: 0.35,
    x: 0,
    y: 0
  })));
};
SvgEntityNode.defaults = SvgEntityNodeDefaultProps;
SvgEntityNode.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;